export default "__VITE_ASSET__Cil9fK8K__"